import React, { useEffect, useState } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';

const API_URL = process.env.REACT_APP_API_URL || 'https://your-backend-project.vercel.app';

function CatalogList() {
  const [catalogs, setCatalogs] = useState([]);
  const [selectedCatalog, setSelectedCatalog] = useState(null);
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // Fetch catalogs on component mount
  useEffect(() => {
    const fetchCatalogs = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/products`);
        const products = response.data.products || response.data;
        setCatalogs(Array.isArray(products) ? products : []);
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching catalogs:', error);
        setCatalogs([]);
        setIsLoading(false);
      }
    };
    fetchCatalogs();
  }, []);

  // Fetch products when a catalog is selected
  useEffect(() => {
    if (selectedCatalog) {
      const fetchProducts = async () => {
        setIsLoading(true);
        try {
          const response = await axios.get(`/api/gelato/catalogs/${selectedCatalog.uid}/products`);
          setProducts(response.data.products);
          setIsLoading(false);
        } catch (error) {
          console.error('Error fetching products:', error);
          setIsLoading(false);
        }
      };
      fetchProducts();
    }
  }, [selectedCatalog]);

  if (isLoading) {
    return <div className="loading-spinner"></div>;
  }

  return (
    <div>
      <h2>Select a Catalog</h2>
      <ul>
        {catalogs.length > 0 ? (
          catalogs.map(catalog => (
            <li key={catalog.uid} onClick={() => setSelectedCatalog(catalog)}>
              {catalog.name}
            </li>
          ))
        ) : (
          <p>No catalogs available</p>
        )}
      </ul>

      {selectedCatalog && (
        <div>
          <h3>Products in {selectedCatalog.name}</h3>
          <div className="product-grid">
            {products.map(product => (
              <div key={product.uid} className="product">
                <img src={product.previewUrl} alt={product.name} className="product-image" />
                <div className="product-info">
                  <h4>{product.name}</h4>
                  <p>{product.description}</p>
                  <button>Add to Cart</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

CatalogList.propTypes = {
  // Define prop types if necessary
};

export default CatalogList;
